// extracted by mini-css-extract-plugin
export default {"richTextEditor":"styles_richTextEditor__rVfbw","wrapper":"styles_wrapper__SMzfJ","editor":"styles_editor__UpOGF"};